module.exports = __webpack_public_path__ + "static/media/login-bg-2.e858783c.jpg";